import { useSiteContent } from '@/context/SiteContentContext';

export default function Hero() {
  const { content } = useSiteContent();
  const h = content.hero;

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full min-h-screen flex items-center">
      <div className="absolute inset-0">
        <img src={h.bgImage} alt="GeoEng Systems" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-950/90 via-teal-900/70 to-teal-800/40"></div>
      </div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 border border-teal-400/50 rounded-full px-4 py-1.5 mb-8 max-w-full">
            <span className="w-2 h-2 flex-shrink-0 rounded-full bg-teal-400 animate-pulse"></span>
            <span className="text-teal-300 text-xs font-semibold tracking-widest uppercase break-words">{h.badge}</span>
          </div>
          <h1 className="font-bold text-white mb-6 flex flex-col gap-3">
            <span className="block text-[1.15rem] sm:text-2xl md:text-5xl leading-tight md:leading-normal whitespace-nowrap">{h.headline1}</span>
            <span className="block text-[1.15rem] sm:text-2xl md:text-5xl leading-tight md:leading-normal text-teal-400 whitespace-nowrap">{h.headline2}</span>
            <span className="block text-[1.15rem] sm:text-2xl md:text-5xl leading-tight md:leading-normal whitespace-nowrap">{h.headline3}</span>
          </h1>
          <p className="text-white/75 text-lg md:text-xl leading-relaxed mb-10 max-w-xl">{h.subtext}</p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button onClick={() => handleNav('#contact')} className="bg-teal-500 hover:bg-teal-400 text-white font-semibold px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap text-base">{h.ctaPrimary}</button>
            <button onClick={() => handleNav('#services')} className="border border-white/40 hover:border-white text-white font-semibold px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap text-base backdrop-blur-sm">{h.ctaSecondary}</button>
          </div>
          <div className="mt-16 flex flex-wrap gap-10">
            {[{ value: '10+', label: 'Years of Excellence' }, { value: '100+', label: 'Years Combined Expertise' }, { value: '15+', label: 'Countries Served' }, { value: '50+', label: 'Projects Completed' }].map((stat) => (
              <div key={stat.label}>
                <div className="text-3xl font-bold text-teal-400">{stat.value}</div>
                <div className="text-white/60 text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/50 text-lg"></i>
      </div>
    </section>
  );
}
